import { TFunction } from 'i18next';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { DateCell } from '../date/component';
import { DateCellViewModel } from '../date/viewModel';
import { ManagedTableGridColDef } from '../../../../../lib/components/compound/table';

export class UpdatedAtCellViewModel extends DateCellViewModel {
  get cellValue() {
    if (this.receipt.updatedAt) {
      return this.receipt.updatedAt.format();
    }
    return '-';
  }

  static buildColDef(t: TFunction): ManagedTableGridColDef {
    return {
      field: 'updatedAt',
      type: 'date',
      filterable: false,
      headerName: t('common:CHANGED'),
      minWidth: 76,
      flex: 1,
      renderCell: (params: GridRenderCellParams<UpdatedAtCellViewModel>) => (
        <DateCell {...params} />
      ),
      getOrderingString: (desc = false) => (desc ? '-updated_at' : 'updated_at')
    };
  }
}
